import { useAuth } from '../contexts/AuthContext';
import { LogOut, User } from 'lucide-react';

const SimpleAuthButton = () => {
  const { isAuthenticated, user, logout, loading } = useAuth();

  if (loading) {
    return (
      <button disabled className="btn btn-primary">
        Loading...
      </button>
    );
  }

  if (!isAuthenticated) {
    return null; // Don't show anything if not authenticated (login is full-page now)
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <User size={16} />
        <span style={{ fontSize: '0.875rem' }}>
          {user?.name || user?.email || 'User'}
        </span>
      </div>
      <button onClick={logout} className="btn btn-secondary">
        <LogOut size={16} />
        Sign Out
      </button>
    </div>
  );
};

export default SimpleAuthButton;